import { defineCustomElement } from 'vue'
import FoundationConnect from './FoundationConnect.ce.vue'

// Register custom elements
const FoundationConnectElement = defineCustomElement(FoundationConnect)
customElements.define('foundation-connect', FoundationConnectElement)

export { FoundationConnectElement }
